import { render, staticRenderFns } from "./PcqDsiCreateUpdate.vue?vue&type=template&id=3818f4a7&scoped=true&"
import script from "./PcqDsiCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./PcqDsiCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PcqDsiCreateUpdate.vue?vue&type=style&index=0&id=3818f4a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3818f4a7",
  null
  
)

export default component.exports